import type { PromotionEcommerceType, SelectPromotionType, TrackingEventType } from './types/types';
import { trackEvent } from 'modules/tracking/dataLayer';
import type { MouseEvent } from 'react';

export default function trackSelectPromotion({
    ecommerce,
    trackingType
}: { ecommerce: PromotionEcommerceType; trackingType: TrackingEventType }) {
    if (!window.dataLayer) {
        window.dataLayer = [];
    }

    const result: SelectPromotionType = {
        event: 'select_promotion',
        $type: trackingType,
        ecommerce
    };

    trackEvent(result);
}
